import { ReactNode } from 'react';
import { IconCheck, IconMessageCircle, IconX, IconClock } from '@tabler/icons';
import { Badge, BadgeProps } from '#root/components/ui/primitives';

type Variant = NonNullable<BadgeProps['variant']>;

interface StatusConfig {
  variant: Variant;
  icon: ReactNode;
}

const STATUS_BY_EST: Record<string, StatusConfig> = {
  '1': { variant: 'info', icon: <IconMessageCircle size={14} /> },
  '2': { variant: 'success', icon: <IconCheck size={14} /> },
  '4': { variant: 'error', icon: <IconX size={14} /> },
  '5': { variant: 'error', icon: <IconX size={14} /> },
  '6': { variant: 'warning', icon: <IconClock size={14} /> },
  '7': { variant: 'error', icon: <IconX size={14} /> },
};

interface OfferStatusBadgeProps {
  est: string;
  label: string;
  size?: BadgeProps['size'];
}

const OfferStatusBadge = ({ est, label, size = 'md' }: OfferStatusBadgeProps) => {
  const config = STATUS_BY_EST[est];
  if (!config || !label) return null;
  return (
    <Badge variant={config.variant} size={size} icon={config.icon}>
      {label}
    </Badge>
  );
};

export default OfferStatusBadge;
